'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHECKOUT_ACTION_RENEW = exports.RENEW_CHECKOUT_EVENT = exports.CHECKOUT_GTM_CATEGORY = undefined;
exports.composeRenewCheckoutEvent = composeRenewCheckoutEvent;

var _compose = require('./compose');

var CHECKOUT_GTM_CATEGORY = exports.CHECKOUT_GTM_CATEGORY = 'v2-checkouts';

var RENEW_CHECKOUT_EVENT = exports.RENEW_CHECKOUT_EVENT = 'bc.renewCheckout';

var CHECKOUT_ACTION_RENEW = exports.CHECKOUT_ACTION_RENEW = 'v2-renew';

function composeCheckoutEvent(eventName, eventValue, eventAction) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: eventValue,
    gtmAction: eventAction,
    gtmCategory: CHECKOUT_GTM_CATEGORY
  });
}

function composeRenewCheckoutEvent(checkoutIds) {
  return (0, _compose.composeAnalytics)([composeCheckoutEvent(RENEW_CHECKOUT_EVENT, checkoutIds.length, CHECKOUT_ACTION_RENEW)]);
}

exports.default = {
  CHECKOUT_GTM_CATEGORY: CHECKOUT_GTM_CATEGORY,
  RENEW_CHECKOUT_EVENT: RENEW_CHECKOUT_EVENT,
  CHECKOUT_ACTION_RENEW: CHECKOUT_ACTION_RENEW,
  composeRenewCheckoutEvent: composeRenewCheckoutEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/checkoutsEventComposer.js
// module id = 991
// module chunks = 1